import React from 'react'
import img2043 from '../components/images/dpurplle.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2043} alt='purplle' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Purple Listing Services
                    </h2>
                    <p>Maximize your sales potential on Purple with our comprehensive listing services designed to optimize visibility and drive growth. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services :</h3>
                <li><b>•	Product Listing:</b> Create compelling product listings with detailed descriptions, high-quality images, and strategic keywords to attract Purple shoppers. </li>
                <li><b>•	Advertising Campaign:</b>Strategically plan and execute advertising campaigns to increase product visibility and drive sales on Purple’s platform. </li>
                <li><b>•	Coupons:</b> Set up and manage discount coupons to incentivize purchases and enhance customer engagement. </li>
                <li><b>•	Promotion:</b> Implement promotional strategies such as flash sales and seasonal promotions to boost product sales on Purple. </li>
                <li><b>•	Brand Registry:</b>Assist brands in registering with Purple’s Brand Registry to protect intellectual property and enhance brand credibility. </li>
                <li><b>•	Category Approval:</b> Facilitate the approval process for listing products in specific categories on Purple, ensuring compliance with platform requirements. </li>
                <li><b>•	GTIN Exemption:</b> Guide sellers in obtaining GTIN exemptions to streamline product listing processes on Purple. </li>
                <li><b>•	Account Health:</b>Monitor and maintain the health of your Purple seller account to ensure compliance with platform policies and performance standards. </li>
                <li><b>•	Order Processing:</b> Efficiently manage order processing from receipt to fulfillment, ensuring timely delivery and customer satisfaction.</li>
                <li><b>•	Payment Reconciliation:</b> Oversee payment reconciliation to ensure accurate transaction records and resolve discrepancies promptly. </li>
                <li><b>•	Keyword Optimization:</b> Optimize product listings with relevant keywords to improve search rankings and visibility on Purple. </li>
                <li><b>•	Sales Boost:</b> Implement effective strategies to boost sales through optimized listings, promotions, and advertising efforts.</li>
                <p>Unlock your full potential on Amazon with our expert management services. Contact E Seller Support for more information and to get started on your journey to success.</p>
            </ul>
        </>
    )
}

export default events